import { render } from "./ViDepartureAndArrival.vue?vue&type=template&id=6f8012ce&scoped=true"
import script from "./ViDepartureAndArrival.vue?vue&type=script&lang=js"
export * from "./ViDepartureAndArrival.vue?vue&type=script&lang=js"

import "./ViDepartureAndArrival.vue?vue&type=style&index=0&id=6f8012ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f8012ce"

export default script